<ion-header mode="ios" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button fill="clear" color="dark" mode="ios" (click)="dismiss('cancel')">
        {{ 'BUTTON.CANCEL' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ 'VIEW.EXPORT.FIELD_SELECTION.TITLE' | translate }} ({{selectedFieldKeys.length}}/{{fields.length}})
    </ion-title>
    <ion-buttons slot="end">
      <ion-button
        strong
        fill="clear"
        color="primary"
        mode="ios"
        [disabled]="!hasSelectedFields"
        (click)="dismiss('confirm')">
        {{ 'BUTTON.EXPORT' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="modal-content">
  <ion-item class="checkbox-toggle-item" lines="full">
    <ion-checkbox
      label-placement="end"
      [checked]="allFieldsSelected"
      (ionChange)="onToggleAllChanged($event.detail.checked)">
      <h5 class="checkbox-toggle-item__label">{{ 'VIEW.EXPORT.FIELD_SELECTION.SELECT_ALL' | translate }}</h5>
    </ion-checkbox>
  </ion-item>
  <ion-list lines="inset">
    @for (field of fields; track field.key) {
      <ion-item class="checkbox-field-item">
        <ion-checkbox
          label-placement="end"
          [checked]="selectedFieldKeys.includes(field.key)"
          (ionChange)="onFieldCheckedChanged(field.key, $event.detail.checked)">
          <p class="checkbox-field-item__label">{{ field.label }}</p>
        </ion-checkbox>
      </ion-item>
    }
  </ion-list>
</ion-content>
